import type { FC } from "react";

import { Checkbox, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { StyledDropdownItem, ItemText, ItemRight } from "./styledComponents";

interface CustomDropdownItemProps {
    id: string;
    text: string;
    visitsText?: string;
    isChecked: boolean;
    isDisabled?: boolean;
    onClick: () => void;
    tooltipContent?: string;
}

const CheckboxDropdownItem: FC<CustomDropdownItemProps> = ({
    text,
    visitsText,
    isChecked,
    isDisabled,
    onClick,
    tooltipContent = "analysis.content.lob.legend.tooltip",
}) => {
    const content = (
        <StyledDropdownItem
            onClick={isDisabled ? undefined : onClick}
            isSelected={isChecked}
            isDisabled={isDisabled}
        >
            <ItemText>{text}</ItemText>
            <ItemRight>
                {visitsText ? <span>{visitsText}</span> : null}
                <Checkbox
                    selected={isChecked}
                    size="sm"
                />
            </ItemRight>
        </StyledDropdownItem>
    );

    if (isDisabled) {
        return (
            <PlainTooltip
                placement="top"
                tooltipContent={translate(tooltipContent)}
            >
                {content}
            </PlainTooltip>
        );
    }

    return content;
};

export default CheckboxDropdownItem;
